import { iGameTemplate, iSquareSaved } from "../context/interfaces";
import { searchHorizontal, searchVertical } from "./searchs";


export default function getPossibleClue(matrix: iSquareSaved[][], template: iGameTemplate): {
  clueText: string,
  clueNumber: string,
  orientation: "horizontal" | "vertical",
  focusedHouse: { column: number, row: number }
} {

  let clueNumber = '';
  let clueText = '';

  var result = searchHorizontal(matrix, template, clueNumber, clueText, "horizontal");
  if (false !== result) {
    return result;
  }

  result = searchVertical(matrix, template, clueNumber, clueText, "vertical");
  if (false !== result) {
    return result;
  }
  //All board are completed so lets find the first possible clue
  for (let row = 0; row < matrix.length; row++) {
    for (let column = 0; column < matrix[row].length; column++) {
      if (matrix[row][column]?.palavraHorizontal && matrix[row][column]?.palavraHorizontal !== -1) {
        clueNumber = matrix[row][column].palavraHorizontal.toString();
        clueText = template.chaves.horizontal[matrix[row][column].palavraHorizontal.toString()][0].chave;

        return { clueNumber, clueText, orientation: "horizontal", focusedHouse: { row, column } };
      }

      if (matrix[row][column]?.palavraVertical && matrix[row][column]?.palavraVertical !== -1) {
        clueNumber = matrix[row][column].palavraVertical.toString();
        clueText = template.chaves.vertical[matrix[row][column].palavraVertical.toString()][0].chave;

        return { clueNumber, clueText, orientation: "vertical", focusedHouse: { row, column } };

      }
    }
  }

  //PODE ESTAR ERRADO, ESSA PARTE FOI INSERIDA PARA QUE HAJA SEMPRE AO MENOS UM RETORNO, MAS NAO ESTAVA NO CODIGO DO CARNEIRO
  return { clueNumber, clueText, orientation: "vertical", focusedHouse: { row: 0, column: 0 } };
}
